// apps/website/src/components/LoadingSpinner.tsx

export function LoadingSpinner({ message = 'Loading...' }: { message?: string }) {
    if ((window as any).__DG_DEBUG) console.log('[spinner:render]', message);
    return (
      <div className="flex items-center justify-center h-screen w-full bg-slate-50">
        <p className="text-lg font-medium text-slate-600">{message}</p>
      </div>
    );
  }
  
  export default LoadingSpinner;
  